const transitionEnd = require('./transition-end').default;

let showData = {};
let what = '[data-interaction="enable-disable"]';
const oncls = 'interaction-active';

function init(item) {
  const triggerEvent = 'click';

  if (item) {
    what = item;
  }

  showData = {
    what,
    triggerEvent,
  };

  $(what).on(`${triggerEvent}`, (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(e.target);
  });
}

function toggle(item, cb) {
  // transitionEnd can be called if/when we call toggle with a 3rd argument
  if (cb) {
    transitionEnd.once(item, cb);
  }

  item.classList.toggle(oncls);
}

function destroy() {
  $(showData.what).off(showData.triggerEvent);
}

module.exports = {
  init,
  toggle,
  destroy,
};
